import Link from 'next/link';

import { cn } from '@/lib/utils';

export function Logo({ className }: { className?: string }) {
  return (
    <Link
      href="/"
      className={cn(
        'text-foreground flex items-center gap-2 no-underline',
        className,
      )}
    >
      <span className="font-logo text-2xl font-bold">Keeps</span>
    </Link>
  );
}
